import { FieldValues, Control, Path } from 'react-hook-form';

import {
  TreeViewSelectDialogProps,
  TreeViewSelectDialog,
} from '../tree-view-select/tree-view-select-dialog';
import { FormControl, FormMessage, FormField, FormItem } from '.';
import { cn } from '../../utils';

interface FormTreeViewSelectProps<T extends FieldValues = FieldValues> {
  size?: 'medium' | 'small' | 'large';
  formControl: Control<T>;
  className?: string;
  name: Path<T>;
}

export function FormTreeViewSelect<T extends FieldValues = FieldValues>({
  disabled = false,
  confirmButtonLabel,
  cancelButtonLabel,
  nodeEditedLabel,
  componentProps,
  nodeGroupLabel,
  placeholder,
  formControl,
  className,
  children,
  options,
  title,
  nodes,
  name,
}: Omit<TreeViewSelectDialogProps, 'onValueChange' | 'value'> & FormTreeViewSelectProps<T>) {
  return (
    <FormField
      render={({ field }) => (
        <FormItem className={cn('relative z-0', className)}>
          <FormControl>
            <TreeViewSelectDialog
              confirmButtonLabel={confirmButtonLabel}
              cancelButtonLabel={cancelButtonLabel}
              nodeEditedLabel={nodeEditedLabel}
              componentProps={componentProps}
              nodeGroupLabel={nodeGroupLabel}
              onValueChange={field.onChange}
              placeholder={placeholder}
              value={field.value ?? []}
              disabled={disabled}
              options={options}
              nodes={nodes}
              title={title}
            >
              {children}
            </TreeViewSelectDialog>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
      control={formControl}
      name={name}
    />
  );
}
